import { render } from "./QuestionsPage.vue?vue&type=template&id=101a4c46&ts=true"
import script from "./QuestionsPage.vue?vue&type=script&lang=ts"
export * from "./QuestionsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Questions/QuestionsPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "101a4c46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('101a4c46', __exports__)) {
    api.reload('101a4c46', __exports__)
  }
  
  module.hot.accept("./QuestionsPage.vue?vue&type=template&id=101a4c46&ts=true", () => {
    api.rerender('101a4c46', render)
  })

}


export default __exports__